import {charcoal} from '../sass/base/_exports.sass';

export const RightAlignIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1, width = 32, height = 32} = props;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        style={{
          fillRule: 'evenodd',
          clipRule: 'evenodd',
        }}
        d="M0.5 1C0.5 0.447715 0.947715 0 1.5 0H15.5C16.0523 0 16.5 0.447715 16.5 1C16.5 1.55228 16.0523 2 15.5 2H1.5C0.947715 2 0.5 1.55228 0.5 1Z"
        fill={color}
      />
      <path
        style={{
          fillRule: 'evenodd',
          clipRule: 'evenodd',
        }}
        d="M8.5 5C8.5 4.44772 8.94772 4 9.5 4H15.5C16.0523 4 16.5 4.44772 16.5 5C16.5 5.55228 16.0523 6 15.5 6H9.5C8.94772 6 8.5 5.55228 8.5 5Z"
        fill={color}
      />
      <path
        style={{
          fillRule: 'evenodd',
          clipRule: 'evenodd',
        }}
        d="M0.5 9C0.5 8.44772 0.947715 8 1.5 8H15.5C16.0523 8 16.5 8.44772 16.5 9C16.5 9.55228 16.0523 10 15.5 10H1.5C0.947715 10 0.5 9.55228 0.5 9Z"
        fill={color}
      />
      <path
        style={{
          fillRule: 'evenodd',
          clipRule: 'evenodd',
        }}
        d="M8.5 13C8.5 12.4477 8.94772 12 9.5 12H15.5C16.0523 12 16.5 12.4477 16.5 13C16.5 13.5523 16.0523 14 15.5 14H9.5C8.94772 14 8.5 13.5523 8.5 13Z"
        fill={color}
      />
    </svg>
  );
};
